import script from "./free-translation-requests.vue?vue&type=script&setup=true&lang=js"
export * from "./free-translation-requests.vue?vue&type=script&setup=true&lang=js"

import "./free-translation-requests.vue?vue&type=style&index=0&id=fe382424&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HP\\Desktop\\dashboard-pro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe382424"]])

export default __exports__